export type ToolCategory = '전체' | '최적화' | '편집' | '변환' | '만들기' | '보안'

export type WorkbenchGroup = '줄이기' | '바꾸기' | '손보기' | '지우기'

export type ToolId =
  | 'compress'
  | 'resize'
  | 'crop'
  | 'convert-jpg'
  | 'convert-png'
  | 'html-to-image'
  | 'rotate'
  | 'watermark'
  | 'editor'
  | 'upscale'
  | 'remove-bg'
  | 'meme'
  | 'blur'

export interface ToolDefinition {
  id: ToolId
  title: string
  shortTitle: string
  description: string
  category: Exclude<ToolCategory, '전체'>
  workbenchGroup: WorkbenchGroup
  action: string
  badge?: string
  accent: 'yellow' | 'blue' | 'mint' | 'pink' | 'violet' | 'orange'
  multiple: boolean
}

export interface ImageItem {
  id: string
  file: File
  preview: string
  width: number
  height: number
}

export interface ProcessedImage {
  id: string
  sourceId: string
  name: string
  blob: Blob
  url: string
  width: number
  height: number
  originalSize: number
}

export interface ToolOptions {
  quality: number
  resizeMode: 'pixels' | 'percent'
  width: number
  height: number
  percent: number
  keepAspect: boolean
  noUpscale: boolean
  cropX: number
  cropY: number
  cropWidth: number
  cropHeight: number
  outputFormat: 'image/jpeg' | 'image/png' | 'image/webp'
  rotation: -90 | 90 | 180
  flipHorizontal: boolean
  flipVertical: boolean
  watermarkText: string
  watermarkPosition: 'top-left' | 'top-right' | 'center' | 'bottom-left' | 'bottom-right'
  opacity: number
  fontSize: number
  textColor: string
  brightness: number
  contrast: number
  saturation: number
  grayscale: number
  upscale: 2 | 4
  tolerance: number
  memeTop: string
  memeBottom: string
  blur: number
}

export const defaultToolOptions: ToolOptions = {
  quality: 78,
  resizeMode: 'pixels',
  width: 1200,
  height: 800,
  percent: 50,
  keepAspect: true,
  noUpscale: true,
  cropX: 0,
  cropY: 0,
  cropWidth: 800,
  cropHeight: 600,
  outputFormat: 'image/png',
  rotation: 90,
  flipHorizontal: false,
  flipVertical: false,
  watermarkText: 'zozinimg',
  watermarkPosition: 'bottom-right',
  opacity: 70,
  fontSize: 42,
  textColor: '#ffffff',
  brightness: 100,
  contrast: 100,
  saturation: 100,
  grayscale: 0,
  upscale: 2,
  tolerance: 24,
  memeTop: '지금 무슨 생각해?',
  memeBottom: '이미지 편집 생각.',
  blur: 12,
}
